var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"chart-root"},[_c('apexchart',{key:_vm.themeMode,attrs:{"options":_vm.options,"series":_vm.data.series,"height":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }